import React from 'react'
import { useIntl } from 'react-intl'

import { AssignmentStatuses } from '@lyrahealth-inc/shared-app-logic/src/features/assignments/types'
import { FormContentHeader } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/formContentHeader/FormContentHeader'
import { FormBody } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/formBody/FormBody'

import { useCareConsent } from './useCareConsent'

export const useCareConsentModalContent = () => {
  const intl = useIntl()
  const careConsent = useCareConsent()
  const consentResponse = careConsent?.assignment_responses?.find(
    (response) => response.status === AssignmentStatuses.completed,
  )

  return (
    <>
      <FormContentHeader title={careConsent?.content?.title} group={careConsent?.content?.group} />
      <FormBody
        schema={careConsent?.content_meta_data?.schema}
        initialValues={consentResponse?.response}
        uiSchema={careConsent?.content_meta_data?.uiSchema}
        instructions={careConsent?.instructions}
        name={careConsent?.content?.name}
        saveForm={() => {}}
        readOnly
        intl={intl}
        formButton={undefined}
        withPageBreaks={false}
        useCustomizedActivityIntroduction={careConsent?.content_meta_data?.useCustomizedActivityIntroduction}
        hasNewLookAndFeel
      />
    </>
  )
}
